module.exports = __webpack_public_path__ + "img/led_strip_rgb_65.a7e9bef3.png";